import { CommonState } from "../state";

import { Occupation } from "./occupations.model";

/**
 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
 */
export namespace OccupationsSelector {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
	 */
	export const getAll = (state: CommonState): Occupation[] | undefined =>
		state.occupations.occupations?.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
}
